// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2iKm3","actions":"GroupTable_actions__bBk6e","deleteModalFooter":"GroupTable_deleteModalFooter__3oXVs"};